var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-3.059-12.267A2.489,2.489,0,0,0-4.828-13H-11.5A2.5,2.5,0,0,0-14-10.5v9A2.5,2.5,0,0,0-11.5,1h9A2.5,2.5,0,0,0,0-1.5V-8.172A2.482,2.482,0,0,0-.733-9.94ZM-11-12h6v3h-6ZM-1-1.5A1.5,1.5,0,0,1-2.5,0h-9A1.5,1.5,0,0,1-13-1.5v-9a1.5,1.5,0,0,1,1-1.408V-9a1,1,0,0,0,1,1h6A1,1,0,0,0-4-9v-2.749a1.485,1.485,0,0,1,.232.189l2.328,2.328A1.49,1.49,0,0,1-1-8.172Zm-6-5A2.5,2.5,0,0,0-9.5-4,2.5,2.5,0,0,0-7-1.5,2.5,2.5,0,0,0-4.5-4,2.5,2.5,0,0,0-7-6.5Zm0,4A1.5,1.5,0,0,1-8.5-4,1.5,1.5,0,0,1-7-5.5,1.5,1.5,0,0,1-5.5-4,1.5,1.5,0,0,1-7-2.5Z",
    transform: "translate(14 13)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6edcd2f4b77c214723f79d6719e6e1b3.svg";
export { ForwardRef as ReactComponent };